import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Box, Button, Grid, TextField, Autocomplete} from 'views/components';
import {Translate, translate, DateTimePicker} from 'views/module';

import moment from 'moment';
import momentTZ from 'moment-timezone';

const RescheduleEvent = (props) => {
  const {closeModel, event, rescheduleEvent, updatedTimes} = props;

  const [startTime, setStartTime] = React.useState(moment(updatedTimes.startTime));
  const [endTime, setEndTime] = React.useState(moment(updatedTimes.endTime));
  const [timezone, setTimezone] = React.useState(updatedTimes.timezone);
  const [reason, setReason] = React.useState('');

  const [isSaving, setIsSaving] = React.useState(false);

  const makeTimezonesList = React.useCallback(() => {
    const timezones = momentTZ.tz.names();
    return timezones.map((tz) => ({
      group: translate('client.ClientDetail.Scheduling.Timezone.Timezones'),
      value: tz,
      label: tz,
    }));
  }, []);
  const onSave = async (e) => {
    setIsSaving(true);
    const reasonForException = {
      description: {
        blob: reason,
        editorType: 'MARKDOWN',
      },
    };
    const eventData = {
      startTime: moment.tz(moment(startTime).format('YYYY-MM-DDTHH:mm:ss'), timezone).format(),
      endTime: momentTZ.tz(moment(endTime).format('YYYY-MM-DDTHH:mm:ss'), timezone).format(),
      timezone: timezone,
    };
    await rescheduleEvent(event.eventRn, reasonForException, eventData);
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="sm" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='schedule.eventDetail.RescheduleDialogTitle.Title'/>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="flex-start" sx={{mt: 0}}>
          <Grid item xs={6}>
            <DateTimePicker
              label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.StartTime')}
              value={startTime}
              onChange={setStartTime}
              textFieldProps={{fullWidth: true, InputLabelProps: {shrink: true}, sx: {mt: 0}}}
            />
          </Grid>
          <Grid item xs={6}>
            <DateTimePicker
              label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.EndTime')}
              value={endTime}
              onChange={setEndTime}
              textFieldProps={{fullWidth: true, InputLabelProps: {shrink: true}, sx: {mt: 0}}}
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              options={makeTimezonesList()}
              value={timezone}
              label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.Timezone')}
              onChange={(e) => setTimezone(e.value)}
              sx={{minWidth: {xs: '192px', md: '256px'}}}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>{option.label}</li>
              )}
              groupBy={(dropdownItem) => dropdownItem.group}
              isOptionEqualToValue={(option, value) => option.value === value}
              disableClearable
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              placeholder={translate('schedule.eventDetail.Reason.ReasonForReschedule')}
              label={translate('schedule.eventDetail.Reason.Reason')}
              value={reason}
              onChange={(e) => setReason(e)}
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving || (endTime && startTime && endTime.isBefore(startTime))}
        >
          <Translate expression="generic.Save" />
        </Button>
      </Box>
    </Dialog>
  );
};

RescheduleEvent.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  rescheduleEvent: PropTypes.func.isRequired,
  updatedTimes: PropTypes.shape({
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    timezone: PropTypes.string,
  }),
};

export default RescheduleEvent;
